export default __webpack_public_path__ + "static/media/p5.39279727.jpg";